import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { buildPageHead, breadcrumbSchema, faqPageSchema } from "@/lib/seo";

/** Verbatim-citable Q&As that answer how AI search engines query the home page. */
export const homeFaqs: { question: string; answer: string }[] = [
  {
    question: "Who is Marjohn Robillo?",
    answer:
      "Marjohn B. Robillo is a Philippines-based Revenue Operations Architect and AI automation engineer who has architected 300+ CRM and revenue systems for agencies in the United States, Canada, Australia, and the UK, specializing in GoHighLevel, HubSpot, n8n orchestration, and agentic Voice AI.",
  },
  {
    question: "What does a Revenue Operations Architect do?",
    answer:
      "A Revenue Operations Architect engineers the end-to-end systems that capture, qualify, route, and convert leads automatically. Marjohn designs CRM automation, n8n workflow orchestration, and Voice AI agents that reduce manual admin by up to 80% and accelerate lead response from hours to under 30 seconds.",
  },
  {
    question: "How much does it cost to hire Marjohn Robillo?",
    answer:
      "Engagements are scoped per project. Marjohn works as a remote contractor for US, Canadian, Australian, and UK agencies, paid via low-fee cross-border transfers such as Wise. Book a free strategy call to receive a custom scope and retainer quote.",
  },
  {
    question: "What platforms and tools does Marjohn specialize in?",
    answer:
      "Marjohn specializes in GoHighLevel and HubSpot CRM architecture, n8n and Make workflow orchestration, Zapier integrations, agentic Voice AI with Vapi, Claude and OpenAI AI agents, webhooks, and custom API automation across multi-location franchise and SaaS deployments.",
  },
  {
    question: "How fast can Marjohn build and deploy a revenue system?",
    answer:
      "Depending on scope, a fully automated lead-to-cash revenue system can be architected and deployed within days to a few weeks, with 300+ live systems already running for clients across four countries.",
  },
];

export const Route = createFileRoute("/")({
  head: () =>
    buildPageHead({
      title: "Marjohn Robillo | RevOps Architect & AI Automation Expert",
      description:
        "300+ CRM systems architected. Hire an elite RevOps & AI automation architect from the Philippines: n8n, agentic voice AI, and revenue operations engineering.",
      path: "/",
      keywords:
        "revenue operations architect, RevOps specialist, CRM automation expert, n8n workflow developer, voice AI automation, Vapi automation, technical virtual assistant Philippines, agentic AI, Marjohn Robillo",
      schema: [
        breadcrumbSchema([{ name: "Home", path: "" }]),
        faqPageSchema(homeFaqs),
      ],
    }),
  component: Index,
});
